import * as Yup from 'yup';
import { Locale } from '@synergy/models';

export const getValidationSchema = (selectedLanguage: Locale) =>
    Yup.object().shape(
        {
            image: Yup.mixed().required('app.error.required'),
            mobileImage: Yup.mixed().required('app.error.required'),
            validFrom: Yup.date().required('app.error.required').typeError('app.error.required'),
            validTo: Yup.date()
                .required('app.error.required')
                .typeError('app.error.required')
                .min(Yup.ref('validFrom'), 'app.error.afterValidFrom'),
            headline: Yup.object().shape({
                [selectedLanguage]: Yup.string(),
            }),
            subHeadline: Yup.object().shape({
                [selectedLanguage]: Yup.string(),
            }),
            // https://github.com/jquense/yup/issues/1036#issuecomment-1151259492
            // the solution is not perfect, because the ctx from property is not typed and not documented
            // it is always possible that the validation breaks in the future with an update of yup
            buttonText: Yup.object().shape({
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                [selectedLanguage]: Yup.string().test('hasButtonUrl', 'app.error.required', (val, ctx: any) => {
                    if (ctx.from[1].value.buttonUrl[selectedLanguage]) {
                        return !!val;
                    }
                    return true;
                }),
            }),
            buttonUrl: Yup.object().shape({
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                [selectedLanguage]: Yup.string().test('hasButtonText', 'app.error.required', (val, ctx: any) => {
                    if (ctx.from[1].value.buttonText[selectedLanguage]) {
                        return !!val;
                    }
                    return true;
                }),
            }),
        },
        [['buttonText', 'buttonUrl']]
    );
